var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-table',{attrs:{"params":_vm.params}})}
var staticRenderFns = []

export { render, staticRenderFns }